import React from 'react';
import { Navigate } from 'react-router-dom';
import LazyLoader from '../components/lazyLoader';

type ProtectedElementProps = {
  assignedPermissions: string[];
  requiredPermissions: string[];
  element: React.ReactElement;
  matchAll?: boolean; // optional prop: true => require all, false (default) => require any
};

export const ProtectedElement = ({
  assignedPermissions,
  requiredPermissions,
  element,
  matchAll = true, // default is "every" match
}: ProtectedElementProps) => {
  const hasAccess = matchAll
    ? requiredPermissions.every(p => assignedPermissions.includes(p))
    : requiredPermissions.some(p => assignedPermissions.includes(p));

  return hasAccess ? <LazyLoader>{element}</LazyLoader> : <Navigate to="/something-went-wrong" replace />;
};

